import { BaseCartClient } from "@core/types";
import { CartState } from "@core/types";

class CartClient extends BaseCartClient {
  async updateCart(cart: CartState): Promise<CartState | null> {
    throw Error("updateCart not implemented");
  }
}

export default CartClient;
